import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Pagination, PagingResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {
  ClaimDocumentLineSplitContainerModel,
  ClaimLineEngagementReportContainerModel,
  MyClaimDocumentLineContainerModel
} from '../../../../../../models';
import {Observable} from 'rxjs';
import {EngagementReportBodyRequest} from '../../../../../../models/aggregates/erp/claim/claim-line-engagement-report-container.model';

export class RequestBodyForStaffReport {
  calcTotalRecords: boolean;
  limit: number | null;
  snapshot?: string;
  orderBy?: string;
  order?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MyClaimDocumentLineService extends BaseApiTemplateService<MyClaimDocumentLineContainerModel> {
  static readonly LINE_PROCESSORS_PREFIX = 'document-lines/processors/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'document-lines/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'document-lines/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'document-lines/backoffice-ep';
    this.httpClient = http;
  }

  public getByCriteriaLoginEntityEp(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<MyClaimDocumentLineContainerModel>> {
    const url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX
      + Core2Config.CLAIMS_PREFIX + 'document-lines/login-entity-ep';
    let epURL = Core2Config.DOMAIN_URL + url;
    if (visa.api_domain_url) {
      epURL = visa.api_domain_url + url;
    }
    const UrlByCriteria = epURL + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MyClaimDocumentLineContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  WithdrawLines(lines: any[], visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + MyClaimDocumentLineService.LINE_PROCESSORS_PREFIX + 'withdrawals/login-entity-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + MyClaimDocumentLineService.LINE_PROCESSORS_PREFIX + 'withdrawals/login-entity-ep';
    }
    return this.httpClient.put(url, lines, this.getHttpHeader(visa));
  }

  onHold(lines: any[], visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + MyClaimDocumentLineService.LINE_PROCESSORS_PREFIX + 'on-hold/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + MyClaimDocumentLineService.LINE_PROCESSORS_PREFIX + 'on-hold/backoffice-ep';
    }
    return this.httpClient.put(url, lines, this.getHttpHeader(visa));
  }

  onAccept(lines: any[], visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'document-lines/finance-acceptance/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'document-lines/finance-acceptance/backoffice-ep';
    }
    return this.httpClient.put(url, lines, this.getHttpHeader(visa));
  }

  resubmitLines(lines: any[], visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + MyClaimDocumentLineService.LINE_PROCESSORS_PREFIX + 'resubmission/login-entity-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + MyClaimDocumentLineService.LINE_PROCESSORS_PREFIX + 'resubmission/login-entity-ep';
    }
    return this.httpClient.put(url, lines, this.getHttpHeader(visa));
  }

  createTempClaimLine(line: MyClaimDocumentLineContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<MyClaimDocumentLineContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'document-lines/temp/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'document-lines/temp/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<MyClaimDocumentLineContainerModel>>(url, line, this.getHttpHeader(visa));
  }

  createMultipleClaimLine(lines: MyClaimDocumentLineContainerModel[], visa: ApiVisa): Observable<BasicApiResponseModel<MyClaimDocumentLineContainerModel[]>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'document-lines/multiple/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'document-lines/multiple/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<MyClaimDocumentLineContainerModel[]>>(url, lines, this.getHttpHeader(visa));
  }

  getStaffReport(body: RequestBodyForStaffReport, apiVisa: ApiVisa): Observable<PagingResponseModel<MyClaimDocumentLineContainerModel>> {
    this.apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/document-lines/staff-reports/login-entity-ep/query';
    if (apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/document-lines/staff-reports/login-entity-ep/query';
    }
    return this.httpClient.post<PagingResponseModel<MyClaimDocumentLineContainerModel>>(this.apiUrl, body, this.getHttpHeader(apiVisa));
  }

  getStaffReportPrimaryEP(body: RequestBodyForStaffReport, apiVisa: ApiVisa): Observable<PagingResponseModel<MyClaimDocumentLineContainerModel>> {
    this.apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/document-lines/staff-reports/login-entity-primary-ep/query';
    if (apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/document-lines/staff-reports/login-entity-primary-ep/query';
    }
    return this.httpClient.post<PagingResponseModel<MyClaimDocumentLineContainerModel>>(this.apiUrl, body, this.getHttpHeader(apiVisa));
  }

  deleteMultipleLines(guids: string[], apiVisa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/document-lines/multiple/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/document-lines/multiple/backoffice-ep';
    }
    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode
      ? apiVisa.tenantCode
      : '';
    const options = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode,
        appId: apiVisa.applet_code
      }),
      body: guids,
    };

    return this.httpClient.delete<BasicApiResponseModel<any>>(apiUrl, options);
  }

  autoSaveLine(dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let url;
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'document-lines/auto-save/backoffice-ep';
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  splitClaimLines(bodyRequest: ClaimDocumentLineSplitContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let url;
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'document-lines/split-claims/backoffice-ep';
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      url,
      bodyRequest,
      this.getHttpHeader(visa)
    );
  }

  getEngagementReports(body: EngagementReportBodyRequest, apiVisa: ApiVisa): Observable<PagingResponseModel<ClaimLineEngagementReportContainerModel>> {
    this.apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/reports/engagement-reports/backoffice-ep';
    if (apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/reports/engagement-reports/backoffice-ep';
    }
    return this.httpClient.post<PagingResponseModel<ClaimLineEngagementReportContainerModel>>(this.apiUrl, body, this.getHttpHeader(apiVisa));
  }

  exportSalaryPayment(claimCycleGuid: any, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'document-lines/cycle-reports/salary-payment/export/csv/backoffice-ep?claim_cycle_guids=' + claimCycleGuid;
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'document-lines/cycle-reports/salary-payment/export/csv/backoffice-ep?claim_cycle_guids=' + claimCycleGuid;
    }

    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

}


